$(".js-popover").on("click", function(e) {
    $(".dropdown-menu").toggleClass("show");
});

$(".js-popover").hover(function(){
    $(".js-popover").css("background-color", "#fafafa");
    }, function(){
    $(".js-popover").css("background-color", "#FFF");
});



var activate_autosave = function () {
    var i = $(this);
    var timeout;
    if (i.data('aactivated')) return;
    i.data('aactivated', 'yes');

    var delay = 500;
    var v = i.val();
    if (i.is('[type="checkbox"]')) {
        if (i.is(':checked')) v = i.val();
        else v = '';
    }
    i.data('lastval', v);
    i.on('blur change keyup', function (e) {
            var new_term  = false;
            if (e.keyCode && e.keyCode == 13) {
                $(this).blur();
                end_term_edit();
                if (i.data('field') == 'data') {
                    new_term = true;
                    delay = 1;
                }
            }
            var v = i.val();
            if (i.is('[type="checkbox"]')) {
                if (i.is(':checked')) v = i.val();
                else v = '';
            }
            if (timeout) clearTimeout(timeout);
            if (v == i.data('lastval')) return;
            timeout = setTimeout(function () {
                    val = v;
                    $.post(i.data('save'), {value: val}, function () {
                            i.data('lastval', val);
                            if (new_term) {
                                i.parents('.group:first').find('.addterm').click();
                            }
                            if (window.syncTitles) {
                                if (top && top.builditEditor) {
                                     top.builditEditor.syncTitles();
                                }
                            }
                        });
                    }, delay);
    });
};

jQuery(function ($) {
    var countdown = $('.countdown');
    if (countdown.length) {
        setInterval(function () {
            var s = countdown.data('seconds');
            countdown.data('seconds', --s);
            var ss = s % 60;
            if (ss < 10) ss = '0' + ss;
            if (s < 1) {
                countdown.text('0:00');
            } else {
                countdown.text(Math.floor(s/60) + ':' + ss);
            }
        }, 1000);
    }

    $('.autosave').each(activate_autosave);

    $('#save_school').click(function (e) {
        e.preventDefault();
        var params = {};
        params.code = $('#school [name="access_code"]').val();
        $.post('/access_code', params, function (res) {
            $('#school_results').html(res.result);
            if (res.ok) {
                $('#school [name="access_code"]').hide();
                $('#save_school').hide();
            }
        }, 'json');
    });

    $('#save_account').click(function (e) {
        e.preventDefault();
        var params = {};
        params.name = $('#account [name="name"]').val();
        params.email = $('#account [name="email"]').val();
        params.password = $('#account [name="password"]').val();
        params.password2 = $('#account [name="password2"]').val();
        $.post('/profile', params, function (res) {
            $('#account_results').html(res.result);
            $('#account [name="password"]').val('');
            $('#account [name="password2"]').val('');
        }, 'json');
    });

    var showing = false;
    $('.toggle-names').click(function (e) {
        if (showing) {
            $('body').addClass('hide-names');
            if ($(this).is('a')) $(this).text('Show Names');
            // $(this).addClass('show-names');
        } else {
            $('body').removeClass('hide-names');
            if ($(this).is('a')) $(this).text('Hide Names');
            // $(this).text('Hide Names');
            // $(this).removeClass('show-names');
        }
        showing = !showing;
    });


    var ac_timer = null;
    $('[data-autocomplete]').on('input', function (e) {
        var input = this;
        var ac = $('.autocomplete');
        if (ac.length == 0) {
            ac = $('<div class="autocomplete"><div class="autocomplete-wrap">>/div></div>');
            ac.css('width', $(this).css('width'));
            ac.data('element', this);
            $(this).after(ac);
            ac.hide();
        }

        if ($(input).val().length == 0) {
            ac.remove();
            return;
        }

        ac.on('click', '.autocomplete-option', function (e) {
            $(input).val($(e.currentTarget).text());
            ac.remove();
        });

        var q = $(this).val();
        if (ac_timer) clearTimeout(ac_timer);
        ac_timer = setTimeout(function () {
            $.post('/autocomplete', {q: q}, function (results) {
                var opt;
                ac.find('.autocomplete-wrap').empty();
                for (var i=0; i<results.length; i++) {
                    opt = $('<div class="autocomplete-option"></div>');
                    opt.html(results[i].replace('<','&lt;').replace(new RegExp(q,'i'), '<span class="autocomplete-option-match">$&</span>'));
                    ac.find('.autocomplete-wrap').append(opt);
                }
                if (results.length == 0) ac.hide();
                else ac.show();
            }, 'json');
        }, 250);
    });

    $('body').on('click', '[data-student-status]', function (e) {
        var info = $(this).data('student-status').split(',');
        $.get('/lesson_status', {app: info[0], lid: info[1]}, function (res) {
            $('#student-status-modal').find('.modal-body').empty().append(res);
            $('#student-status-modal').find('.modal-title').text($(res).find('.title').text());
            $('#student-status-modal').modal('show');
        });
    });
    $('.static-math').each(function () {
        MathQuill.getInterface(2).StaticMath(this);
    });

    
});